import type { ReactNode } from 'react'

export function StateBlock({
  tone = 'muted',
  title,
  children,
}: {
  tone?: 'muted' | 'error' | 'warn' | 'info'
  title?: string
  children: ReactNode
}) {
  return (
    <div className={`pp-state pp-state--${tone}`} role="status">
      {title ? <strong>{title}</strong> : null}
      <div>{children}</div>
    </div>
  )
}

export function PageHeader({
  eyebrow,
  title,
  children,
}: {
  eyebrow: string
  title: string
  children?: ReactNode
}) {
  return (
    <header className="cp-page__head">
      <div>
        <p className="cp-eyebrow">{eyebrow}</p>
        <h1>{title}</h1>
        {children}
      </div>
    </header>
  )
}
